import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(date: string, format: string = 'MM/DD/YYYY'): any {
    return moment(date).format(format);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/date-format.pipe.ts